"use client"

import { Fragment } from 'react'
import { useAppDispatch, useAppSelector } from "@/hooks/redux"
import { Col, Row, Select, Typography } from "antd";
import { productActions } from '@/lib/redux/features/product/reduce';
import ProductLabel from '@/components/common/ProductLabel';

const BundleProducts = () => {
  const bundle = useAppSelector(state => state.product.design_detail.data.bundle)
  const bundleData = useAppSelector(state => state.product.design_detail.data.bundle_data)

  const dispatch = useAppDispatch()

  if (!bundle) {
    return <></>;
  }

  return (
    <>
      {bundleData.map(p => {
        const selectedVariant = p.variants.find(v => v.selected)
        return (
          <Fragment key={p.id}>
            <Row>
              <ProductLabel
                labelSetting={{
                  type: 'text',
                  text: p.attributes_name,
                  image: ""
                }}
              />
            </Row>
            <Row gutter={[10, 10]}>
              <Col span={24}>
                <Select
                  value={selectedVariant?.id}
                  size='large'
                  style={{ width: "100%", minHeight: "5rem" }}
                  options={p.attributes_values.map(({ title, id }) => {
                    return {
                      label: title,
                      value: id,
                    }
                  })}
                  onChange={(v) => {
                    dispatch(productActions.selectVariantBundleProduct({
                      productId: p.id,
                      variantId: v
                    }))
                  }}
                />
              </Col>
            </Row>
          </Fragment>
        )
      })}
    </>
  )
}

export default BundleProducts